import update from 'immutability-helper';

import * as LoginActions from 'auth/actions';
import { LoginStatusModel, notLoggedInStatus } from './models';
import { getInitialLoginState } from './utils';

const initialState: LoginStatusModel = getInitialLoginState();

/**
 * Reducer that maintains the state of the user (is the user logged in, etc.)
 */
export function loginStateReducer(state = initialState, action: LoginActions.ActionTypes): LoginStatusModel {
    switch (action.type) {
        case LoginActions.Types.LOGIN_SUCCESS:
            return update(state, {
                loginErrorMessage: {$set: null},
                name: {$set: action.name},
                token: {$set: action.token},
                username: {$set: action.username},
                avatarUrl: {$set: action.avatarUrl},
                permissions: {$set: action.permissions},
                onboardingStatus: {$set: action.onboardingStatus},
                acceptedCookieAgreement: {$set: action.acceptedCookieAgreement},
            });
        case LoginActions.Types.LOGIN_FAILURE:
            return update(state, {
                loginErrorMessage: {$set: action.errorMessage},
                name: {$set: ''},
                token: {$set: ''},
                username: {$set: ''},
            });
        case LoginActions.Types.LOGOUT_SUCCESS:
            return notLoggedInStatus;
        default:
            return state;
    }
}
